import { render } from "./ProductsSignUp.vue?vue&type=template&id=d9c97cc8&scoped=true"
import script from "./ProductsSignUp.vue?vue&type=script&lang=js"
export * from "./ProductsSignUp.vue?vue&type=script&lang=js"

import "./ProductsSignUp.vue?vue&type=style&index=0&id=d9c97cc8&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Jude\\Desktop\\projects\\creditclan\\clan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9c97cc8"]])

export default __exports__